import axios from 'axios'
import { coreClient, getToken } from '@/api/coreclient'
import type { TemplateAIAttributes } from 'common'

const apiUrl = import.meta.env.VITE_API_URL

export default {
  async fillExcel(
    body: unknown,
    useDevFile: boolean = false,
    hiddenTabs?: string,
    deletedTabs?: string
  ) {
    const token = await getToken()

    let url = '/templater/excel'

    if (useDevFile) {
      url += '?useDevFile=true'
    }

    return axios.post(apiUrl + url, body, {
      responseType: 'blob',
      params: {
        hiddenTabs,
        deletedTabs
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  async getAllReportTemplates(): Promise<Pick<TemplateAIAttributes, 'id' | 'name'>[]> {
    const client = await coreClient()
    const templates = await client.templater.listReportTemplates()
    templates.sort((a, b) => a.name.localeCompare(b.name))
    return templates
  },
  async generateReport(
    templateId: number,
    body: unknown,
    useDevFile: boolean = false,
    hiddenTabs?: string,
    deletedTabs?: string
  ): Promise<string> {
    const client = await coreClient()
    return client.templater.generateReport(templateId, body, useDevFile, hiddenTabs, deletedTabs)
  }
}
